import { BillType, ORDER_TYPE, TAKEAWAY_STATUS } from '../../../all-types'

export const defaultBillType: BillType = {
  billNo: '',
  sNo: 0,
  clientId: '',
  orderType: ORDER_TYPE['DINE-IN'],
  takeAwayStatus: TAKEAWAY_STATUS.PENDING,
  takeAwayType: "NONE",
  items: [],
  billingInfo: {
    totalItemsCostRaw: 0,
    totalDiscountIssued: 0,
    totalTaxCharged: 0,
    TaxChargeSheetView: {},
    finalBillAmount: 0,
    extraInfo:{}
  },
  info: {
    createdBy: "DEFAULT",
    sessionId: "",
    tableId: "",
    tableName: "",
    tableNo: ""
  },
  timeInfo: {
    billDate: '',
    billTime: '',
    timestamp: '',
    timezone: '',
    year: 0,
  },
  modeOfPayment: '',
}
